import history from '../../history'

export function pathnameSelector(state) {
  //return state.routing.pathname
  return history.location.pathname
}



// WEBPACK FOOTER //
// ./src/redux/modules/routeModule.js